import React from 'react';

import { LookoBadge } from '@looko-design-system';
import { SvgIcon } from '@mui/material';

import useGetShopInfo from '@/app/shop/shop-info/useGetShopInfo';
import 세컨솔드_관리_라우터, { 세컨솔드_관리_페이지_라우터 } from '@/router/acloset-management';
import { basicRoles } from '@/router/consts';
import { useShopAuth } from '@/state/userAuthContext';

import SecondsoldLogoIcon from '../../../assets/icon/icon_secondSold.svg?react';
import type { SidebarMenu } from '../../types';

/**
 * 세컨솔드 관리 메뉴 훅
 */
export const useSecondsoldManagementMenus = () => {
  const shopAuth = useShopAuth();
  const shopID = shopAuth.shopID;

  const { data: shopInfo } = useGetShopInfo(shopID);

  return React.useMemo(() => {
    if (shopInfo == null) {
      return [];
    }

    return [
      {
        title: 세컨솔드_관리_페이지_라우터.index.handle.title,
        path: 세컨솔드_관리_페이지_라우터.index.path,
        icon: <SvgIcon component={SecondsoldLogoIcon} />,
        roles: basicRoles,
        childrenMenus: 세컨솔드_관리_라우터
          .filter(v => v.handle?.displayInSidebarMenu === true)
          .map((v): SidebarMenu => {
            const defaultMenu = {
              title: v.handle?.title ?? '제목 없음',
              path: v.path,
              display: true,
            };

            if (
              v.path === 세컨솔드_관리_페이지_라우터.배송_공지사항_설정.path &&
              shopInfo?.acloset.isLogixNoticePublished
            ) {
              return {
                ...defaultMenu,
                badge: <LookoBadge color="red1" label={'게시 중'} />,
              };
            }

            return defaultMenu;
          }),
      },
    ];
  }, [shopInfo?.acloset.isLogixNoticePublished]);
};
